import React from 'react';
import config from '../../../../shared/services/config';

export const SearchInput = ({ placeholder, isRounded, onChange, value, fullWidth, disabled }) => {
  const UI = config.get('uiv2', {})

  return <UI.Input
    wrapperClassName={isRounded ? '!tw-rounded-24' : ''}
    placeholder={placeholder}
    onChange={onChange}
    value={value}
    fullWidth={fullWidth}
    disabled={disabled}
    suffix={(
      <span className='tw-p-8 tw-flex'>
        <UI.PayuIcon type='search' size='16px' className='tw-text-gray-100' />
      </span>
    )}
  />
}